import _ from 'underscore';

import { DURATION_SCALES } from 'constants/general';

/**
 * @param {*} a
 * @returns True if a explicitely null or undefined.
 */
export const isNullOrUndefined = (a) => {
	// This is the only case where == should be used instead of ===
	if (a == null) return true;
	return false;
};

/**
 * Returns true if a is a JSON Object like: {}
 * @param {*} a
 */
export const isObject = (a) => !!a && a.constructor === Object;

export const formatDuration = (t, tKey, originalTimeInDays) => {
	let time = 0 + originalTimeInDays;
	let timeText;

	if (time === 0) {
		timeText = t(`${tKey}.today`);
		return { time, timeText };
	}

	timeText = t(`${tKey}.hour`, { count: time });

	for (let i = 0; i < DURATION_SCALES.length - 1; i += 1) {
		if (time >= DURATION_SCALES[i].nextThreshold) {
			time = Math.round(time / DURATION_SCALES[i].nextFactor);
			timeText = t(`${tKey}.${DURATION_SCALES[i + 1].scale}`, { count: time });
		} else break;
	}

	return { time, timeText };
};
